import RuntimeConfig from '../model/RuntimeConfig'

const prodRuntimeConfig: RuntimeConfig = {
  ssrSharedCache: true,
  brandName: 'B2C',
  salesChannel: 'webLLY',
  apiGateway: 'https://mas-sales-front.k8s.masmovil.com/api',
  salesClusterUrl: 'https://sales.k8s.masmovil.com',
  vistaApiGateway: 'https://mas-care-front.k8s.masmovil.com/customer',
  consentsUrl: 'https://mas-consents-front.prod-01.k8s.masmovil.com',
  energyUrl: 'https://manage.masmovilenergia.tools/',
  configCatSDKKey: 'SyLYCI3UakmOim9hszs9jA/1O3-OSVJGUKOllDm7HbkGw',
  defaultFeatureFlags: { isOffline: false },
  analytics: {
    UAID: 'UA-2853174-30',
    externalConfigName: 'b2c-sales',
    siteName: 'MAS SALES',
  },
  authn: {
    clientId: 'uZaI63oICXb6LYU1sYRn',
    apiGateway: 'https://authn.masstack.com/v1',
  },
  redisUrl: 'redis://redis:6379/2',
  environment: 'production',
}

export default prodRuntimeConfig
